import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PaginatorPresentation from './PaginatorPresentation';

export default class Paginator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            rowsPerPage: 0,
            totalRows: 0,
            totalPages: 0,
        };
    }

    componentDidMount() {
        const { startPage, rowsPerPage, totalRows } = this.props;

        if (startPage) {
            this.setState({ currentPage: startPage });
        }

        if (rowsPerPage) {
            this.setState({ rowsPerPage: rowsPerPage });
        }

        if (totalRows) {
            this.setState({ totalRows: totalRows });
        }

        if (totalRows) {
            const resultTotalPages = Math.ceil(
                totalRows / (rowsPerPage || this.state.rowsPerPage),
            );
            this.setState({ totalPages: resultTotalPages });
        }
    }

    componentDidUpdate(prevProps) {
        const { totalRows } = this.props;
        const { rowsPerPage } = this.state;
        if (prevProps.totalRows !== totalRows) {
            const resultTotalPages = Math.ceil(totalRows / rowsPerPage);
            this.setState({
                totalRows: totalRows,
                totalPages: resultTotalPages,
            });
        }
    }

    nextPage() {
        const { totalPages, currentPage } = this.state;
        const auxCurrentPage = currentPage;
        const newPage = auxCurrentPage + 1;
        if (newPage < totalPages) {
            if (this.props.onChangePage) {
                this.props.onChangePage(newPage);
            }
            this.setState({ currentPage: newPage });
        }
    }

    previousPage() {
        const { currentPage } = this.state;
        const auxCurrentPage = currentPage;
        const newPage = auxCurrentPage - 1;
        if (newPage >= 0) {
            if (this.props.onChangePage) {
                this.props.onChangePage(newPage);
            }
            this.setState({ currentPage: newPage });
        }
    }

    handleRowsPerPage(newAmount) {
        const { totalRows } = this.state;
        const resultTotalPages = Math.ceil(totalRows / Number(newAmount));
        this.setState({
            currentPage: 0,
            rowsPerPage: Number(newAmount),
            totalPages: resultTotalPages,
        });

        if (this.props.onChangeRowsPerPage) {
            this.props.onChangeRowsPerPage(Number(newAmount));
        }
    }

    render() {
        const { currentPage, totalPages, rowsPerPage } = this.state;
        return (
            <PaginatorPresentation
                nextPage={this.nextPage.bind(this)}
                previousPage={this.previousPage.bind(this)}
                currentPage={currentPage + 1}
                totalPages={totalPages}
                rowsPerPage={String(rowsPerPage)}
                itemsRowsPerPage={[25, 50, 100]}
                handleRowsPerPage={this.handleRowsPerPage.bind(this)}
            />
        );
    }
}

Paginator.propTypes = {
    totalRows: PropTypes.number.isRequired,
    startPage: PropTypes.number,
    rowsPerPage: PropTypes.number,
    onChangePage: PropTypes.func,
    onChangeRowsPerPage: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Paginator/index.js